import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { House } from "@phosphor-icons/react";
import { Logo } from "@/components/Logo";
import { Footer } from "@/components/Footer";

export function Section({ title, children }) {
  return (
    <section className="sb-card p-5">
      <h2 className="text-lg font-heading font-semibold text-gray-900 mb-2">{title}</h2>
      <div className="font-body text-gray-700 leading-relaxed text-sm space-y-2">{children}</div>
    </section>
  );
}

export function LegalLayout({ title, testid, updated = "Juni 2026", children }) {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="mx-auto max-w-md min-h-[100dvh] px-6 py-8 sm:border-x-2 sm:border-gray-800 space-y-4" style={{ background: "var(--app-bg)" }} data-testid={testid}>
      <Link to="/" data-testid="legal-home-link" className="flex items-center gap-1 font-heading text-gray-600 hover:text-gray-900"><House size={20} weight="bold" />Zur Startseite</Link>
      <div className="flex flex-col items-center mb-2"><Logo className="h-14" /></div>
      <h1 className="text-2xl font-heading font-semibold text-gray-900">{title}</h1>
      <p className="font-body text-xs text-gray-400">Stand: {updated}</p>
      {children}
      <Footer />
    </div>
  );
}
